var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeotagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 11.6L9 16.6667C9.5 17.3333 10.5 17.3333 11 16.6667L14.8 11.6C15.5789 10.5614 16 9.29822 16 8C16 4.68629 13.3137 2 10 2C6.68629 2 4 4.68629 4 8C4 9.29822 4.42107 10.5614 5.2 11.6Z",
    stroke: "#373D4D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 2,
    stroke: "#373D4D",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotagIcon);
export default __webpack_public_path__ + "static/media/geotag-icon.209d7e660f0efe37058998b0b3f4f66e.svg";
export { ForwardRef as ReactComponent };